import lineChart from 'assets/img/illustrations/crm-line-chart.png';
import Flex from 'components/common/Flex';
import React, { useEffect, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import { useToast } from 'context/providers/ToastProvider';

const TitleSelector = ({
    vendedores,
    setVendedores,
    dateQuarter,
    setDateQuarter,
    idUsuario, 
    setIdUsuario,
    setMes,
    title1,
    title2,
    barChart
}) => {
   
    const { token, setToken, idCatTipoUsuario } = useToken();
    const { showErrorToast } = useToast();
    const [cargando, setCargando] = useState(true); 

    const ObtenerListaVendedores = async (date) => {
        setCargando(true);
        let dateStr = "";
        if (date) {
            dateStr = new Date(date).toLocaleDateString('es-MX', {
                year: 'numeric', month: '2-digit', day: '2-digit', hour12: false
            });
        }
        const response = await fetch(`/api/home/ObtenerListaVendedoresEstadisticas${dateStr ? `?date=${encodeURIComponent(dateStr)}` : ''}`, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);

            });

        if (response.ok) {
            console.log(response);
            const data = await response.json();
            //Tabla con lista de vendedores
            setVendedores(data);
            setIdUsuario(idUsuario);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);

    };

    useEffect(() => {
        ObtenerListaVendedores(dateQuarter);
    }, [dateQuarter]);

    return (
        <Card className="bg-100 shadow-none border mb-3">
            <Card.Body className="py-0">
                <Row className="g-0 justify-content-between">
                    <Col sm="auto">
                        <Flex alignItems="center">
                            <img src={barChart} width={90} alt="..." className="ms-n4" />
                            <div>
                                <h4 className="text-primary fw-bold mb-0">
                                    {title1}
                                    <span className="text-info fw-medium"> {title2}</span>
                                </h4>
                            </div>
                            <img
                                src={lineChart}
                                width={140}
                                alt="..."
                                className="ms-n4 d-md-none d-lg-block"
                            />
                        </Flex>
                    </Col>
                    <Col md="auto" className="mb-1 mt-1 mb-md-3">
                        <Row className="g-3 gy-md-0 h-100 align-items-center">
                            <Col xs="auto">
                                {idCatTipoUsuario == 1 &&
                                    <Form.Select
                                        size="md"
                                        aria-label="Default select"
                                        value={idUsuario}
                                        onChange={(e) => {
                                            setIdUsuario(e.target.value);
                                        }}
                                    >
                                        <option value="0">{cargando ? "Cargando vendedores..." : "All Sale Agents"}</option>
                                        {vendedores.map((vendedor, index) => {
                                            return (<option key={index} value={vendedor.idUsuario} className={vendedor.bIsActive === false ? "text-danger" : ""}>{vendedor.vNombre} {vendedor.vApellidos}</option>)
                                        })}

                                    </Form.Select>
                                }
                            </Col>
                            <Col md="auto">
                                <DatePicker
                                    selected={dateQuarter}
                                    onChange={(date) => {
                                        console.log("date: ", date);
                                        setDateQuarter(date);
                                        var date_ = new Date(date).toLocaleDateString('es-MX', {
                                            year: 'numeric', month: '2-digit', day: '2-digit', hour12: false
                                        });
                                        setMes(date_)
                                    }}
                                    dateFormat="MMMM yyyy - QQQ"
                                    className="form-control w-100"
                                    showMonthYearPicker />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};


TitleSelector.propTypes = {
    vendedores: PropTypes.array,
    setVendedores: PropTypes.func,
    setDateQuarter: PropTypes.func,
    idUsuario: PropTypes.number,
    dateQuarter: PropTypes.instanceOf(Date),
    setIdUsuario: PropTypes.func,
    setMes: PropTypes.func,
    title1: PropTypes.string,
    title2: PropTypes.string,
    barChart: PropTypes.string
};


export default TitleSelector;